import { FILTER_TYPE } from '../utils/constants';

/**
 * Override Filters with field overrides
 * @param {FilterSelection[]} filters - Array of filters.
 * @param {Object[]} fieldsConfig - fields configuration.
 * @param {Object} fieldsConfig[].overrides - Individual field overrides.
 * @returns {FilterSelection[]} - Array of filters
 */
const overrideFilters = (filters, fieldsConfig) => {

    filters.forEach((filter) => {
    
        const fieldConfig = fieldsConfig.find(({ id, type = FILTER_TYPE.default }) => id === filter.fieldId && type === filter.type) || {};
    
        if (fieldConfig.overrides) {

            filter.updateFieldProperties(fieldConfig.overrides);

        }

    });

    return filters;

};

export default overrideFilters;